import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "markerWidth", "markerHeight", "refX", "refY"]
const _hoisted_2 = ["d", "fill", "transform"]

import { computed, PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LinePointMarker',
  props: {
  id: {
    type: String,
    required: true,
  },
  position: {
    type: String as PropType<'start' | 'end'>,
    required: true,
  },
  type: {
    type: String as PropType<'dot' | 'arrow'>,
    required: true,
  },
  color: {
    type: String,
  },
  baseSize: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const pathMap = {
  dot: 'm0 5a5 5 0 1 0 10 0a5 5 0 1 0 -10 0z',
  arrow: 'M0,0 L10,5 0,10 Z',
}
const rotateMap = {
  'arrow-start': 180,
  'arrow-end': 0,
}

const path = computed(() => pathMap[props.type])
const rotate = computed(() => rotateMap[`${props.type}-${props.position}`] || 0)
const size = computed(() => props.baseSize < 2 ? 2 : props.baseSize)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("marker", {
    id: `${__props.id}-${__props.type}-${__props.position}`,
    markerUnits: "userSpaceOnUse",
    orient: "auto",
    markerWidth: _unref(size) * 3,
    markerHeight: _unref(size) * 3,
    refX: _unref(size) * 1.5,
    refY: _unref(size) * 1.5
  }, [
    _createElementVNode("path", {
      d: _unref(path),
      fill: __props.color,
      transform: `scale(${_unref(size) * 0.3}, ${_unref(size) * 0.3}) rotate(${_unref(rotate)}, 5, 5)`
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})